/**
 * Durations as CrowdSec prints them and as a person reads them.
 *
 * Shared because both ends meet CrowdSec's text: the agent reads what is left of a
 * ban from the Local API (P5.2), and the helper reads it from `cscli decisions list`
 * before deciding whether a ban it was asked for is already in place (P5.4).
 */
/** Go's duration syntax as CrowdSec prints it: `3h59m30s`, `29m59s`, `-17s`, `1.5s`. */
export function parseGoDuration(text) {
    const match = /^(-)?(?:(\d+)h)?(?:(\d+)m(?!s))?(?:(\d+(?:\.\d+)?)s)?(?:(\d+)ms)?$/.exec(text.trim());
    if (match === null || text.trim() === '' || text.trim() === '-')
        return undefined;
    const [, sign, hours, minutes, seconds, millis] = match;
    if (hours === undefined &&
        minutes === undefined &&
        seconds === undefined &&
        millis === undefined) {
        return undefined;
    }
    const total = Number(hours ?? 0) * 3600 +
        Number(minutes ?? 0) * 60 +
        Number(seconds ?? 0) +
        Number(millis ?? 0) / 1000;
    return sign === '-' ? -total : total;
}
/**
 * A duration as a person would say it. `3h59m30s` is what is left of a 4 h ban
 * thirty seconds after it was made, and "4h" is what anybody means by it.
 */
export function describeDuration(seconds) {
    if (seconds < 60)
        return seconds <= 0 ? 'no time' : 'under a minute';
    const minutes = Math.round(seconds / 60);
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    const rest = minutes % 60;
    const parts = [];
    if (days > 0)
        parts.push(`${String(days)}d`);
    if (hours > 0)
        parts.push(`${String(hours)}h`);
    if (rest > 0 && days === 0)
        parts.push(`${String(rest)}m`);
    return parts.slice(0, 2).join(' ');
}
//# sourceMappingURL=duration.js.map